module.exports = __webpack_public_path__ + "img/certif_08.cf5efd53.jpg";